<template>
  <div class="footer">
    <footer class="site-footer footer pt-3">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h6>About Us</h6>
            <p class="text-justify"> Finult Advisors Private Limited <br><strong>CIN:</strong> U74999KA2017PTC108243 </p>
          </div>
          <div class="col-xs-6 col-md-3">
            <h6>Categories</h6>
            <ul class="footer-links">
              <li><a href="#">About Us</a></li>
              <li>
                <router-link :to="{ name: 'ContactUs' }"
                  >Contact Us</router-link
                >
              </li>
            </ul>
          </div>
          <div class="col-xs-6 col-md-3">
            <h6>Quick Links</h6>
            <ul class="footer-links">
              <li>
                <router-link :to="{ name: 'TermsAndConditions' }"
                  >Terms and conditions</router-link
                >
              </li>
              <li><a href="#">Sitemap</a></li>
            </ul>
          </div>
        </div>
        <hr />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">
              Copyright &copy; 2024 All Rights Reserved by
              <a href="#">Finult</a>.
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <ul class="social-icons">
              <li>
                <a class="facebook" href="#"><i class="fab fa-facebook"></i></a>
              </li>
              <li>
                <a class="twitter" href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li>
                <a class="linkedin" href="#"><i class="fab fa-linkedin"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <button onclick="topFunction()" id="myBtn" title="Go to top">
      <span class="material-icons">keyboard_arrow_up</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style></style>
